import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=df5d9d8e&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=df5d9d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5d9d8e",
  null
  
)

export default component.exports